import { render, staticRenderFns } from "./TuiError.vue?vue&type=template&id=fe7cde58&scoped=true"
import script from "./TuiError.vue?vue&type=script&lang=ts"
export * from "./TuiError.vue?vue&type=script&lang=ts"
import style0 from "./TuiError.vue?vue&type=style&index=0&id=fe7cde58&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe7cde58",
  null
  
)

export default component.exports